export default __webpack_public_path__ + "static/Edital-VITALIS-2025-108df4a323c43aeae376404fb1f5cf8c.pdf";